export function loadScript (src: string, attrs: Record<string, string> = {}) {
    return new Promise<null>((res, rej) => {
        const script = document.createElement('script')
        script.src = src

        for (const key in attrs) {
            script.setAttribute(key, attrs[key])
        }

        script.onload = () => res(null)
        script.onerror = (err) => rej(err)
        
        document.head.appendChild(script)
    })
}